module.exports = __webpack_public_path__ + "static/media/pin.62eb6621.svg";